import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'inputLabel'
})
export class InputLabelPipe implements PipeTransform {
    transform(forminput: any, args?: any): string {
        return forminput.placeholder ? this.__with__placeholder__(forminput) : this.__no__placeholder__(forminput)
    }
    private __no__placeholder__(forminput: any): string {
        return forminput.mendatory ? forminput.label + '*' : forminput.label
    }

    private __with__placeholder__(forminput: any): string {
        return forminput.mendatory ? forminput.placeholder + '*' : forminput.placeholder
    }
}